import appSyncClient from '../../appsync/client';
import createUser from '../../appsync/mutations/CreateUser';
import { getCurrentUserEmail } from '../../utils/auth/authenticatedUser';

export default (allowResearch, isGuestUser, language) => {
  const timestamp = new Date().toString();

  if (isGuestUser) {
    return Promise.resolve({ allowResearch, dateAgreedToMobileTerms: timestamp });
  }

  return getCurrentUserEmail()
    .then((email) => {
      appSyncClient
        .mutate({
          mutation: createUser(email, !!allowResearch, timestamp, true, false, language),
        });
    })
    .catch((error) => {
      console.error('Error retrieving user email: ', error); // eslint-disable-line no-console
    });
};
